<mat-sidenav-container class="container">
	<mat-sidenav-content>
		<div class="loading-shade" *ngIf="loading$ | async">
			<mat-progress-bar mode="indeterminate" *ngIf="loading$ | async"></mat-progress-bar>
			<!-- TODO implement an error message -->
			<!-- <div *ngIf="resultsError">
				There was an error retrieving data. Please refresh the page.
			</div> -->
		</div>
		<h1 class="mat-display-1 p-2 m-0 component-header">
			Schedule Field Worker
		</h1>
		<mat-card class="container-fill calendar-container" [formGroup]="calendarFilters">
			<div fxLayout="row">
				<mat-card class="mat-elevation-z0 p-0" fxFill *ngIf="job$ | async as job">
					<h1 mat-dialog-title>
						<a [routerLink]="jobsFragments.detail(job.id)">{{
							job.number
							}}</a>
						&mdash; {{ job.description }}
					</h1>
					<div fxLayout="row" fxLayoutAlign="space-around center" class="job-details">
						<div class="customer-name">{{ job.customer.name }}</div>
						<div class="point-of-contact">
							<mat-icon inline>person_pin</mat-icon>{{
							job.fieldContacts[0]
							| fullName: 'No field contact yet'
							}}
						</div>
						<div class="location">
							<mat-icon inline>location_on</mat-icon>
							<div style="display: inline-block;">
								<span>{{ job.city }}, {{ job.state }}</span><br />
								<span>{{ job.location }}</span>
							</div>
						</div>
						<div class="job-dates">
							<mat-icon inline>date_range</mat-icon>{{ job.start | date: 'MM/dd/yy':'utc' }} -
							{{ job.end | date: 'MM/dd/yy':'utc' }}
						</div>
					</div>
				</mat-card>
			</div>
			<!--weekly calendar controls-->
			<div fxLayout="row" fxLayoutAlign="none center">
				<button mat-raised-button color="primary" class="mr-2" matTooltip="Add Shifts" (click)="addShifts()">
					<mat-icon aria-label="Shifts add button">playlist_add</mat-icon>
					Add Shifts
				</button>
				<rpshared-calendar-paginator fxFlexOffset="5rem" formControlName="byStartDate" fxLayout="row"
					fxLayoutAlign="none center" class="weekly-date-controls">
				</rpshared-calendar-paginator>

				<div fxLayout fxLayoutAlign="end" fxFlex fxLayoutGap="1.5rem">
					<mat-form-field>
						<mat-select formControlName="byRWICAvailablity">
							<mat-option [value]="true">
								Show available Field Workers
							</mat-option>
							<mat-option [value]="false">
								Show all Field Workers
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field>
						<mat-select formControlName="byTeam" [compareWith]="compareTeam" placeholder="Field Team"
							multiple>
							<mat-option *ngFor="let team of fieldTeams$ | async" [value]="team">
								{{ displayFieldTeam(team) }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<!--End weekly calendar controls-->
			<div fxLayout class="calendar-wrapper">
				<div fxLayout="row" fxFlexOffset="15rem" fxFlex style="position: relative;">
					<rpshared-one-week-calendar [startDate]="startDate"></rpshared-one-week-calendar>
				</div>
				<div fxLayout="row">
					<div class="cal-items-with-row-headers">
						<mat-progress-bar mode="indeterminate" *ngIf="loadingRwics$ | async"></mat-progress-bar>
						<mat-form-field>
							<input matInput formControlName="byRWICName" placeholder="Search" />
							<mat-icon matSuffix>search</mat-icon>
						</mat-form-field>
						<rpfsa-job-assignments-weekly [job]="job$ | async"></rpfsa-job-assignments-weekly>
					</div>
				</div>
			</div>
		</mat-card>
	</mat-sidenav-content>
	<mat-sidenav class="p-2" mode="side" [opened]="shiftChanges$ | async" position="end"
		style="min-width: 306px; width: 306px;">
		<rpfsa-job-assignments-summary-pane [job]="job$ | async" [startDate]="startDate">
		</rpfsa-job-assignments-summary-pane>
	</mat-sidenav>
</mat-sidenav-container>